import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import {
    Row,
    Col
} from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

// views
import CadastroFluxoForm from "./CadastroFluxoForm.jsx";

//Context
import { useAuth } from "../../context/auth.js";

export default function CadastroFluxoLista() {
    const { setLoading } = useAuth();

    const [permiteEditar, set_permiteEditar] = React.useState(false);
    const [showDetail, set_showDetail] = React.useState(false);
    const [rowEdit, set_rowEdit] = React.useState(null);
    const [list_table, set_list_table] = React.useState([]);

    const handleAdd = () => {
        set_rowEdit(null);
        set_showDetail(true);
    }

    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        set_showDetail(true);
    }

    const handleReturn = () => {
        set_rowEdit(null);
        set_showDetail(false);
        loadList();
    }

    const loadList = () => {
        setLoading(true);
        api_GET('fluxocadastro')
            .then(result => set_list_table(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("CadastroFluxo.Editar", function (result) { set_permiteEditar(result) });
        loadList();
    }, []);

    return (
        <>
            {!showDetail &&
                <div className="content">
                    <Row>
                        <Col md="12">
                            <button type="submit" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Novo Fluxo</button>
                            <MaterialTable style={{ minHeight: "auto" }}
                                title=""

                                columns={[
                                    { title: 'Configuração de Solicitação', field: 'setupSolicitacaoAcao.setupSolicitacao.descricao' },
                                    {
                                        title: 'Segmento', field: 'setupSolicitacaoAcao.setupSolicitacao.segmento',
                                        render: (rowData) => rowData.setupSolicitacaoAcao.setupSolicitacao.descricao.includes("RSS")
                                            ? rowData.setupSolicitacaoAcao.setupSolicitacao.segmento.replace("Grande", "")
                                            : rowData.setupSolicitacaoAcao.setupSolicitacao.segmento
                                    },
                                    { title: 'Ação', field: 'setupSolicitacaoAcao.acao' },
                                    { title: "Descrição", field: "setupSolicitacaoAcao.identificacao" },
                                    { title: 'Status', field: 'status' },
                                ]}
                                data={list_table}
                                isLoading={false}
                                options={{
                                    ...table_style,
                                    filtering: false,
                                    exportButton: true
                                }}
                                actions={[
                                    {
                                        icon: 'edit',
                                        tooltip: 'Editar Registro',
                                        onClick: (event, rowData) => handleEdit(rowData)
                                    }
                                ]}
                                localization={table_translate}
                            />
                        </Col>
                    </Row>
                </div>
            }
            {showDetail &&
                <CadastroFluxoForm item={rowEdit} handleReturn={handleReturn}></CadastroFluxoForm>
            }
        </>
    );
}